import { interval } from 'rxjs';
import { startWith } from 'rxjs/operators';
import { isPlainObject } from 'is-plain-object';
import { getCookie } from '@utiljs/cookie';
import * as Ids from '@utils/ids';
import request from '@utils/axiosWrapper';
import { getStorage, setStorage } from '@utils/localStorage';
import { reportCustomError } from '@utils/owlReporter';

const POLLING_INTERVAL = 60 * 60 * 1000;

const deviceUuid = getCookie('device_uuid');
const pushToken = getCookie('pushToken') || getCookie('token');

const rateLimitStateCacheKey = 'pushTokenRateLimitState';
/**
 * pushToken 上报限流
 */
const shouldReportPushToken = (): boolean => {
    const currentState = JSON.parse(getStorage(rateLimitStateCacheKey) || '{}');

    const reportKey = `${Ids.getAcctId()}-${getCookie('pushToken') ||
        Ids.getToken()}-${Ids.getDeviceId()}-${Ids.getToken()}`;

    const currentTime = new Date().getTime();

    let result = true;

    if (
        currentState.lastReportKey &&
        currentState.lastReportTime &&
        currentState.lastReportKey === reportKey &&
        currentTime - currentState.lastReportTime < 1200 * 1000
    ) {
        result = false;
    }

    if (result) {
        // 如果需要上报，则更新本地记录
        currentState.lastReportKey = reportKey;
        currentState.lastReportTime = currentTime;
        setStorage(rateLimitStateCacheKey, JSON.stringify(currentState));
    }

    return result;
};

/** 上报 push Token */
const init = () => {
    interval(POLLING_INTERVAL)
        .pipe(startWith(0))
        .subscribe(() => {
            const reportData = {
                uuid: deviceUuid,
                acctId: Ids.getAcctId(),
                pushToken,
                type: 'interval',
                isMuti: 1, // 开启多设备账号设置
            };

            request.postAsFormSubmit('/v2/common/pushToken/w/update', reportData).catch(error => {
                if (!isPlainObject(error)) {
                    throw Error(error.message);
                }
            });
            if (shouldReportPushToken()) {
                if (pushToken.indexOf('%2A') !== -1) {
                    reportCustomError({
                        name: 'pushToken 异常 - 上报',
                        message: `acctId: ${Ids.getAcctId()}, poiId: ${Ids.getWmPoiId()}, pushToken: ${pushToken}, token: ${Ids.getToken()}`,
                        level: 'WARN',
                    });
                }
                request
                    .postAsFormSubmit('/v2/common/v2/pushToken/w/update', reportData)
                    .catch(error => {
                        // 屏蔽限流异常
                        if (
                            !isPlainObject(error) &&
                            (!error ||
                                !error.message ||
                                error.message.indexOf('请求过于频繁') === -1)
                        ) {
                            throw Error(error.message);
                        }
                    });
            }
        });
};

export default { init };
